var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavIconFIlled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10239",
    "data-name": "Group 10239",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M0,0H19V19H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M13.479,3a4.474,4.474,0,0,1,4.354,4.75c0,5.542-5.938,8.708-7.917,9.9C7.938,16.458,2,13.292,2,7.75A4.492,4.492,0,0,1,6.354,3,5.238,5.238,0,0,1,9.917,4.583,5.238,5.238,0,0,1,13.479,3Z",
    transform: "translate(-0.417 -0.625)",
    fill: "#ed6a5e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIconFIlled);
export default __webpack_public_path__ + "static/media/favIconFIlled.0b09acd6f3a274685242ce3439b2fc9d.svg";
export { ForwardRef as ReactComponent };